<template>
  <main>
    <aside class="usm-add-analyst-button-wrapper">
      <router-link to="/useradmin/adduser">
        <button class="btn-floating btn-large waves-effect waves-light teal accent-4">
          <i class="fas fa-plus" />
        </button>
        <label>Add User</label>
      </router-link>
    </aside>
    <article class="row">
      <section class="col s4">
        <label>Type</label>
        <select class="browser-default" v-model="selectedType">
          <option value="all" selected>All</option>
          <option value="analyst">Analyst</option>
          <option value="farm-team">Farm Team</option>
        </select>
      </section>
      <section class="col s4"/>
      <section class="col s4"/>
    </article>
         
    <h4><strong>Users</strong></h4>
    <article class="row">
      <table class="col s12">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Active</th>
            <th>Roles</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="analyst in sortedAnalysts"
              :key="analyst.analyst_id"
              v-show="
                selectedType == 'all' ||
                (analyst.roles.includes('analyst') && selectedType == 'analyst') ||
                (analyst.roles.includes('farm-team') && selectedType == 'farm-team')
              "
          >
            <td>
              <router-link :to="`/useradmin/edituser?analyst_id=${analyst.id}`" class="blue-grey-text text-darken-4">
                <img :src="analyst.avatar" class="avatar circle left">
                <span class="highlight">{{ analyst.name }}</span>
              </router-link>
            </td>
            <td>{{ analyst.email }}</td>
            <td>
              <i class="fas fa-check-circle green-text" v-if="analyst.active" />
              <i class="fas fa-check-circle red-text" v-else/>
            </td>
            <td>
              {{ analyst.roles.join(', ') }}
              <router-link :to="`/useradmin/edituser?analyst_id=${analyst.id}`">
                <i class="far fa-edit clickable amber-text big" />
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Users',
  props: {},
  data() {
    return {
      analysts: [],
      sortField: 'name',
      selectedType: this.$auth.hasRoles('analyst', 'adp') ? 'all' : 'farm-team',
    };
  },
  computed: {
    sortedAnalysts() {
      return this.sortArray(this.analysts, this.sortField);
    },
  },
  watch: {},
  methods: {
    initSelect() {
      this.materialize.FormSelect.init(document.querySelectorAll('select'), {});
    },
  },
  async mounted() {
    this.initSelect();
    const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/`);
    const rolesResponse = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/roles/`);
    const roles = rolesResponse.data;
    // only display users with roles managed by viewing user
    this.analysts = data.filter(user => {
      const userRoleManagers = roles.filter(r => user.roles.includes(r.name)).map(r => r.managers).flat();
      return this.$auth.user.roles.filter(r => userRoleManagers.includes(r)).length;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/main.scss';

.highlight {
  transition: all 0.25s;
  &:hover {
    color: $tmf-blue;
  }
}

.avatar {
  margin-right: 5px;
  height: 20px;
}

.usm-add-analyst-button-wrapper{
  position: absolute;
  top: 100px;
  right: 30px;
  & label {
    display: block;
    margin-top: 8px;
  }
}
</style>
